
// PaymentGatewayModal.js
import React, { useEffect, useState,useRef } from "react";
import { useHistory } from "react-router-dom";
import axios from 'axios'
import config from '../../../config'
import URL from '../../../api/url'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { forwardRef, useImperativeHandle } from "react";
import { getPaypalPaymentURL } from "./Payment";
import { useTranslation } from 'react-i18next';
// import Razorepay from "../../assets/paymenttype/razorepay.png";
// import Paypal from "../../assets/paymenttype/paypal.png";
// import Atom from "../../assets/paymenttype/atom.png";
import "./paymentModel.css";
import {handleCheckboxChange} from "../dueDetails/dueDetail"
import {getPaymentGatewayChecking} from './Payment'
import Loader from "../../../components/loader";
import api from "../../../api/api";
import base64 from "base-64";
import Razorepay from "../../../assets/paymentType/razorepay.png"
import Attom from "../../../assets/paymentType/atom.png"
import CRED from "./cred"

const PaymentGatewayModal = (props) => {
  const { t } = useTranslation();
  const history = useHistory(); // Get history object
  const [extCharge,setExtCharge]=useState(0);
  const [extraCharge, setExtraCharge] = useState(0);
  const [totalAmount, setTotalAmmount] = useState(0);
  const [gateway,setGateway]=useState([])
  const [data1,setData1]=useState([])
  const [originalConvenienceFee,setOriginalConvenienceFee]=useState(0)
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [partialAmount, setPartialAmount] = useState(""); 
  const [totalFee, setTotalFee] = useState(0);
  const [gatewayPopupData, setGatewayPopupData] = useState([]);
    const [gatewayPopupOpen, setGatewayPopupOpen] = useState(true);
    const [actual_amount_paid,setActualAmountPaid]=useState(0);
    const [selectedGateway,setSelectedGateway]=useState("")
    const [dataItem,setDataItem]=useState("")
    const [atomData, setAtomData] = useState(null);
    const [amountTotal,setAmountTotal]=useState(0)
    const [addExtraCharge, setAddExtraCharge] = useState(0);
    const [gatewayPercentage, setGatewayPercentage] = useState(0);
    const [disabledButton, setDisabledButton] = useState(false);
    const [gateWayData, setGateWayData] = useState(null);
const [razorpayAmount, setRazorpayAmount] = useState(null);
const [errorMessage, setErrorMessage] = useState("");  
const [minAllowedWithFine, setMinAllowedWithFine] = useState(0);
const [originalTotalAmountWithCharges, setOriginalTotalAmountWithCharges] = useState(0);


const [noGatewayAvailable, setNoGatewayAvailable] = useState(false);

const { Atom, Razorpay } = props.pr || {}; // ✅ Prevent destructure crash

useEffect(() => {
  setGateway(props.pr || {});
  if (!props.pr || (props.pr?.Atom?.is_active !== "Y" && props.pr?.Razorpay?.is_active !== "Y")) {
    setNoGatewayAvailable(true);
  } else {
    setNoGatewayAvailable(false);
  }
}, [props.pr]);

useEffect(() => {
  getPaymentGatewayFees({ ...props, setAtomData, setRazorpayAmount });
}, []);

const handleClosee = () => {};
const handleOkk = () => {};
    
useEffect(() => {
 
}, [extCharge]);

  
 

 
//   useEffect(() => {
//     if (totalAmount > 0) {
//         razorpayCheckOutForm(); // ✅ Runs after totalAmount is updated
//     }
// }, [totalAmount]);
  // useEffect(() => {
  //   // if (gateway.length) {
  //     console.log("hiiii")
  //     setSelectedGateway(0)
  //     setDataItem(Razorpay)
  //   // }
  // }, [gatewayPopupOpen])

useEffect(() => {
  if (!props.selectedInstallments?.length) return;

  let totalFeeAmount = props.selectedInstallments.reduce(
      (sum, item) => sum + item.d_amount + (parseInt(item.balance_fine) || 0),
      0
  );

  
  // Calculate extra charge based on partial payment or full payment
  let amountToCharge = partialAmount ? Number(partialAmount) : totalFeeAmount;
  setTotalFee(amountToCharge);
  calculateExtraCharge(amountToCharge, props.razorpay_fee, props.student_fee_enable);
  
}, [props.selectedInstallments, props.razorpay_fee, props.student_fee_enable, partialAmount]); 



useEffect(() => {
    if (!props.selectedInstallments?.length) return;

    let totalFeeAmount = props.selectedInstallments.reduce(
        (sum, item) => sum + item.d_amount + (parseInt(item.balance_fine) || 0),
        0
    );

    setTotalFee(totalFeeAmount);

    // Calculate the original convenience fee
    let extraCharge = calculateExtCharge(totalFeeAmount, props.razorpay_fee, props.student_fee_enable);
    
    // ✅ Store the original total amount including charges
    setOriginalTotalAmountWithCharges(totalFeeAmount + extraCharge);
}, [props.selectedInstallments, props.razorpay_fee, props.student_fee_enable]);

  
  useEffect(() => {
    let data=props.pr ?? []
    setData1(data)
   
  
  }, [props.selectedInstallments]);

  // let prop=props.fetchStudent.result
  // console.log("prop",props)


  // console.log(totalAmount)
  const calculatedAtomTotalAmount = () => {
    let totalFeeAmount = props.selectedInstallments.reduce(
      (sum, item) => sum + item.d_amount +item.total_fine,//+ (parseInt(item.balance_fine) || 0)
      0
      
    );
    return Number(totalFeeAmount).toFixed(2);
  };





const getPaymentGatewayFees = async props => {
    const {  openPopup,gateWayData } = props
  
    
    const {
      student_auth,
      setLoader,
      useAtom,
      useRazorpay,
      institute_id,
      country_id,
      
      amount,
      usePaypal,
      message,
      dispatch,
      country_details,
      select_payment_gateway,
    } = props;
    
    let request = {
      url: `/api/v1/payment-gateway/${institute_id}?is_updated_payment_req=true`,
      token: student_auth

    }
    api
      .getAuth(request)
      .then(async (response) => {
        // console.log("inside console .then")
        // console.log("responseeeeee",response)
        let currency_code="INR"
        // console.log("response",response)
        // console.log("reqq",response.status,response.data.statusCode)
        // console.log("props.student_country_details",props.currency_code)
        // console.log("error",response.data.message)
        if (response.status === 200 && response.data.statusCode === 200) {
          if (currency_code === "INR"
          //  && props.student_country_details.currency_code === "INR"
          ) {
              if (response.data.result) {
                  // setGateway(response.data.result);
                  // openPopup();
                  // setAtomData(response.data.result.Atom); // ✅ Store in state instead of calling useAtom()
                  
                  setRazorpayAmount(response.data.result.Razorpay); // ✅ Store Razorpay data
              } else {
                  toast.error(t('fees.paymentNotAllowed'), "fail");
              }
          } else {
              toast.error(t('fees.paymentMethodNotSupported'), "fail");
          }
      } else {
        toast.error(response.data.message, "fail");
      }
  })
  // .catch((err) => {
  //     alert("Error processing payment", "fail");
  // });
  }

 


  // const handleAmountChange = text => {
  //   console.log("handle Amount")
  //   // Regular expression to check for non-numeric characters (except numbers)
  //   const invalidCharacters = /[^0-9]/g

  //   // Convert the text to a number if it's valid, otherwise reset to 0
  //   let numericValue = Number(text) || 0
  //   const totalAmt = totalAmount || 0 // Ensure totalAmt is defined
  //   const installmentData = props.inst_sett_det || [] // Ensure installment_data is defined

  //   // Step 1: Calculate the total balance_fine and array length in one step
  //   const { length: arrayLength, totalBalanceFine } = installmentData.reduce(
  //     (acc, item) => ({
  //       length: acc.length + 1,
  //       totalBalanceFine: acc.totalBalanceFine + item.balance_fine,
  //     }),
  //     { length: 0, totalBalanceFine: 0 },
  //   )

  //   // Step 2: Calculate the minValue based on installment data
  //   const minAllowedWithFine = arrayLength + totalBalanceFine

  //   // Step 3: Calculate the minimum percentage allowed, safely handle undefined part_fee_pay_per
  //   const minAllowedPer = props.inst_sett_det?.part_fee_pay_per ? (totalAmt * props.inst_sett_det.part_fee_pay_per) / 100 : 0

  //   // Check if the input contains invalid characters (special chars or spaces)
  //   if (invalidCharacters.test(text)) {
  //     alert('Only Numeric Values are allowed!')
  //     return // Stop further processing if invalid characters are found
  //   }

  //   // Check if the input is being edited after an initial entry
  //   if (text === '') {
  //     numericValue = 0 // Clear numeric value if the user deletes all input
  //   }

  //   // Validation conditions
  //   if (numericValue > amountTotal) {
  //     alert(`Amount cannot be greater than Rs ${amountTotal.toFixed(2)}`)
  //   } else if (numericValue < minAllowedWithFine) {
  //     alert(`Amount cannot be less than Rs ${minAllowedWithFine.toFixed(2)}`)
  //   }
  //   // Optional: Check if amount is lower than the minimum percentage
  //   // else if (numericValue < minAllowedPer) {
  //   //   setWarning(`Amount cannot be less than Rs ${minAllowedPer}`);
  //   // }
  //   else {
  //     props.handleClose();  
  //     setTimeout(() => {
  //       if (gateway) {
  //           console.log("Opening Razorpay...");
  //           payNowButton(selectedPayment);
  //       } 
  //   }, 300);
      
  //     // update_actual_amount_paid(numericValue) // Proceed with updating the amount
      
  //   }
  // }

  const handleAmountChange = (e) => {
    let text = e.target.value;


    // Keep only numbers
    const sanitizedValue = text.replace(/[^0-9]/g, "");
  
    // Prevent typing more than 7 digits
    if (sanitizedValue.length > 7) return;
  
    setPartialAmount(sanitizedValue);
    let numericValue = Number(sanitizedValue) || 0; // Convert to number, fallback to 0
    const totalAmt = totalFee || 0; // Ensure totalAmount is defined
    const installmentData = props.selectedInstallments || []; // Ensure installment_data is defined

    // Step 1: Calculate the total balance_fine and array length
    const { arrayLength, totalBalanceFine } = installmentData.reduce(
        (acc, item) => ({
            arrayLength: acc.arrayLength + 1,
            totalBalanceFine: acc.totalBalanceFine + item.balance_fine,
        }),
        { arrayLength: 0, totalBalanceFine: 0 }
    );

    // Step 2: Calculate minAllowedWithFine based on installment data
    const minAllowedWithFine = arrayLength + totalBalanceFine;
   

    // Step 3: Calculate the minimum percentage allowed
    const minAllowedPer = props.inst_sett_det?.part_fee_pay_per
        ? (totalAmt * props.inst_sett_det.part_fee_pay_per) / 100
        : 0;

    // Validation checks
    

    // setErrorMessage("");

    // // ✅ Instead of alert(), set error messages
    // if (numericValue > totalAmt) {
    //     setErrorMessage(`Amount cannot be greater than Rs ${totalAmt.toFixed(2)}`);
    // } else if (numericValue < minAllowedWithFine) {
    //     setErrorMessage(`Amount cannot be less than Rs ${minAllowedWithFine.toFixed(2)}`);
    // }
    // Uncomment below if you want to enforce min percentage
    // else if (numericValue < minAllowedPer) {
    //     alert(`Amount cannot be less than Rs ${minAllowedPer}`);
    // }
    
        setPartialAmount(sanitizedValue); 
    
};

const handlePaymentProceed = () => {
  let amountToPay = partialAmount.trim() === "" ? totalFee : Number(partialAmount);
  let totalFeees=totalFee
const installmentData = props.selectedInstallments || []; 
const { arrayLength, totalBalanceFine } = installmentData.reduce(
    (acc, item) => ({
        arrayLength: acc.arrayLength + 1,
        totalBalanceFine: acc.totalBalanceFine + item.balance_fine,
    }),
    { arrayLength: 0, totalBalanceFine: 0 }
);

let totalFeeAmount = props.selectedInstallments.reduce(
  (sum, item) => sum + item.d_amount + (parseInt(item.balance_fine) || 0),
  0
);
const minAllowedWithFine = arrayLength + totalBalanceFine;
    let error = "";
    if (amountToPay > originalTotalAmountWithCharges) {

        error = `Amount cannot be greater than Rs ${(originalTotalAmountWithCharges).toFixed(2)}`;
    } else if (amountToPay < minAllowedWithFine) {
        error = `Amount cannot be less than Rs ${minAllowedWithFine.toFixed(2)}`;
    }

    if (error) {
        setErrorMessage(error);
        return; 
    }
    setErrorMessage("");
    if (selectedPayment === "razorpay") {
      payWithRazorpay(amountToPay);  // ✅ Call Razorpay function
  } else if (selectedPayment === "atom") {
      payWithAtom(amountToPay);  // ✅ Call Atom function with amount
  } else {
      console.error("Invalid payment gateway selected");
  }
};
 
 
// const payNowButton = (selectedPayment, amountToPay) => {
//   if (typeof props.setLoader !== "function") {
//       console.error("setLoader is not a function", props.setLoader);
//       return;
//   }
  
//   console.log("paynow button");
//   console.log("selectedPayment:", selectedPayment);
//   console.log("amountToPay:", amountToPay); // ✅ Log the amount being paid

//   props.setLoader(true);

//   if (selectedPayment === "razorpay") {
//       console.log("Processing Razorpay...");
//       setTotalAmmount(Math.round(totalAmount * 100)); // ✅ Use amountToPay
//        console.log("razzz totla amount",totalAmount)
//       razorpayCheckOutForm()
//           .then(() => props.setLoader(false)) 
//           .catch(() => props.setLoader(false)); 

//   } else if (selectedPayment === "atom") {
//       console.log("Processing Atom...");
//       setTotalAmmount(Math.round(amountToPay * 100)); // ✅ Use amountToPay

//       getAtomPayment(amountToPay) // ✅ Pass amount to Atom payment function
//           .then(() => props.setLoader(false))
//           .catch(() => props.setLoader(false));

//   } else {
//       console.error("Invalid gateway selected");
//       props.setLoader(false);
//   }
// };

// const paypalPayment = async () => {
//   let data = props.selectedInstallments;

//   let schedule_ids = data.map(el => el.f_schld_id);
// console.log("data",data,schedule_ids,totalFee)
//   try {
//     props.setLoader(true);
// console.log("here")
// const payload = {
//   payment_for: "Fee",
//   payment_gateway_account_type: "Client",
//   payment_gateway_name: "PayPal",
//   country_id: 220,
//   currency_code: props.currency_code,
//   response_code: 200,
//   paytab_token: "",
//   amount: totalFee,
//   discription:"",
//   online_payment_amount:totalFee,
//   actual_amount_paid:totalFee,
//   chequeDetailsJson:{},
//   paymentMode: "card",
//   payment_source: "WEB",
//   institute_id: `${props.institute_id}`,
//   paid_date:new Date().toISOString().split('T')[0],
//   razor_payment_id: "", 
//   reference_no: "", 
//   remarks: "", 
//    schedule_ids: schedule_ids,
//     student_id: `${props.student_id}`,
//  version: "v2",
//   intent:"sale"
// };

//     console.log("paypal payload", payload);
//     const url = await getPaypalPaymentURL(payload);
//     window.open(url.replace("redirect:", ""), "_self");
//   } catch (err) {
//     console.error("Redirect failed", err);
//     alert("Could not proceed to payment.");
//   } finally {
//     props.setLoader(false);
//   }
// };

// useImperativeHandle(ref, () => ({
//   paypalPayment,
// }));


const payWithRazorpay = (amountToPay) => {
    if (typeof props.setLoader !== "function") {
        console.error("setLoader is not a function", props.setLoader);
        return;
    }

    props.setLoader(true);

    // Use the original total amount (not affected by Atom input)
    setTotalAmmount(Math.round(amountToPay * 100));

    razorpayCheckOutForm(amountToPay)
        .then(() => props.setLoader(false))
        .catch(() => props.setLoader(false));
    props.handleClose();     
};

const payWithAtom = (amountToPay) => {
    if (typeof props.setLoader !== "function") {
        console.error("setLoader is not a function", props.setLoader);
        return;
    }

    props.setLoader(true);

    // Use the user-entered amount
    // setTotalAmmount(Math.round(amountToPay * 100));

    getAtomPayment(amountToPay)
        .then(() => props.setLoader(false))
        .catch(() => props.setLoader(false));

        props.handleClose();     
};



  const  update_actual_amount_paid = newValue => {
    setActualAmountPaid(newValue)
  }

  const setGatwayData = (data) => {
    if (Object.keys(data).length === 0) {
      toast.error(t('fees.paymentGatewayNotAdded'), 'fail')
    } else {
      setGateway(data)
    }
  }
  const calculateExtraCharge = (totalFees, razorpay_fee, student_fee_enable) => {
    // console.log("hello")
    // console.log("hi",props.selectedInstallments)
    // console.log(totalFeeAmount)
    // console.log("razor",props)
    // console.log(setTotalFee)
    // console.log("pay",props.student_fee_enable)
    if (student_fee_enable === 1) {
    
      let extra_charge = (totalFees *props.razorpay_fee) / 100;
      let gstCharge = (extra_charge * 18) / 100;
      let finalAmount = totalFees + extra_charge + gstCharge;
      setExtraCharge(extra_charge+gstCharge);
      setTotalAmmount(finalAmount);
      setAmountTotal(finalAmount)
    } else {
      setTotalAmmount(totalFee);
      setAmountTotal(totalFee)
    }
  };

  const calculateExtCharge = (totalFees, razorpay_fee, student_fee_enable) => {
    if (student_fee_enable === 1) {
        let extra_chargee = (totalFees * razorpay_fee) / 100;
        let gstChargee = (extra_chargee * 18) / 100;
        let extraa_chargee = extra_chargee + gstChargee;
        let finalAmount = totalFees + extraa_chargee;

      

        return extraa_chargee;  // ✅ Return the extra charge instead of setting state
    } 
    return 0; // Return 0 if no extra charge is applicable
};

   



const loadScript = (src) => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const orderPlaced = async () => {
 history.push("/thankyou"); 
};


const getAtomToken = async (payload) => {

  try {
    let response = {
      url: `/api/v1/payment-gateway/payment/token`,
      data: payload,
      token: props.student_auth,
    };


    let res = await api.postAuth(response);


    if (res.data.statusCode == 200 && res.data.result.token_id !== "") {
      return { token: res.data.result.token_id, cid: res.data.result.cid };
    } else {
      toast.error(res.data.message);
      return null;
    }
  } catch (err) {
    console.error("Error in getAtomToken:", err);

    if (err.response && err.response.message) {
      toast.error(err.response.message);
    } else {
      toast.error(t('fees.unableToPay'));
    }
    return null;
  }
};


const getAtomPayment = async (amountToPay) => {

  let data = props.selectedInstallments;
  let student_id = props.student_id;
  let institute_id = props.institute_id;
  let user_id = props.user_id;

  let installments = data.map(el => el.install_no).join(",");
  let schedule_ids = data.map(el => el.f_schld_id);
  
  //  Use `partialAmount` if entered, otherwise use totalFee
  let finalAmount = partialAmount ? Number(partialAmount) : totalFee;

  // Ensure proper format (avoid decimals if Atom doesn't support them)
  finalAmount = Math.round(finalAmount); // Atom may require whole numbers
  
  const orderCreateRequest = {
    chequeDetailsJson: {},
    paid_date: new Date().toISOString().split('T')[0],
    paymentMode: 'card',
    reference_no: '',
    remarks: '',
    student_id: `${props.student_id}`,
    razor_payment_id: '',
    online_payment_amount: amountToPay, 
    payment_for: 'Fee',
    payment_gateway_account_type: "Client",
    payment_gateway_name: 'Atom',
    country_id: 1,
    currency_code: "INR",
    response_code: 200,
    paytab_token: '',
    amount: amountToPay, 
    payment_source: 'WEB',
    institute_id: `${props.institute_id}`,
    actual_amount_paid: amountToPay, 
    version: 'v2',
    schedule_ids: schedule_ids,
  };


  const payment_url = await getAtomToken(orderCreateRequest);
  
  if (!payment_url) {
    console.error("Failed to get payment URL");
    return;
  }

  const options = {
    atomTokenId: `${payment_url.token}`, 
    merchId: gateway.Atom.merchant_id,
    custEmail:props.user_email ?props.user_email:gateway.Atom.email_id,
    custMobile: props.user_phone,
    returnUrl: `${URL[config.env].PROCTUR_API_URL}/api/v1/payment-gateway/payments/process/${props.institute_id}`,
  };


 
  if (!window.AtomPaynetz) {
    console.error("AtomPaynetz is not available on window object.");
    return;
  }

  window.AtomPaynetz(options);
  
  
  
  
  
};
  

const updateOrder = async (flag, order_data, transaction_id) => {
  const {
    coupon_applied,
    country_id,
    currency_code,
    total_amount,
    discount,
    coupon_details,
  } = this.state;
  const { user_id, access_token, student_auth, institute_id } = this.props;


  let amount = total_amount - discount;
  let payload = {
    entity_id: "123",
    payment_gateway_transaction_id: "123",
    status: 20,
    payment_for: "Product",
    payment_gateway_account_type: "Proctur",
    payment_gateway_name: "Razorpay",
    country_id: "123",
    currency_code: "123",
    response_code: "123",
    paytab_token: "",
  };
  // if (coupon_applied) {
  //   payload["offer_apply_dto"] = coupon_details;
  // }


  let response={
    url:`/prod/order/update`,
    data:payload,
    token:props.student_auth
  }
 api
    .post(response)
    .then((data) => {
      if (data.data.result.status !== 20) {
        // this.handleClose = () => { this.setState({ show_alert: false }) }
        // this.handleOk = () => { this.setState({ show_alert: false }) }
        // this.setState({ show_alert: true, content: messages.unableToPay })
      } else {
        orderPlaced();
      }
      
    })
    .catch((error) => {
      if (error.response && error.response.status == 403) {
        toast.error(
            error.response.data && error.response.data.message
              ? error.response.data.message
              : "",
        );
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.error &&
        Array.isArray(error.response.data.error) &&
        error.response.data.error.length > 0
      ) {
        toast.error("e", error.response.data.error[0].error_message);
      } else {
        toast.error("e", error);
      }
     
    });
};


const updateOrderForRazorPay = async (razorpay_payment_id, order_id) => {
  const payload = {
    razorpay_payment_id: razorpay_payment_id,
    order_id: order_id,
  };
  let response ={
    url:`/api/v2/onlinePayment/update-order-payment-detail`,
    token: props.student_auth,
    data:payload
  }
     api.postAuth(response).then(response=>{
    if (response.data.statusCode === 200) {
      orderPlaced();
    }
  }) .catch( (err) =>{
    const errorMessage =
      err.response && err.response.data && err.response.data.message
        ? err.response.data.message
        : "unableToPay";
        toast.error(errorMessage);
  } )
};

const handleRazorpayPayment = (totalFee, gatewayPercentage, addExtraCharge) => {
  this.razorpayCheckOutForm()
}


const razorpayCheckOutForm = async (amountToPay) => {
  let studentFeeReportJsonList = getStudentFeeReportJsonList()
  let validInstallments = props.selectedInstallments.filter((id) => {
    const inst = props.installments.find((inst) => inst.f_schld_id === id);
    return inst && props.getFeeStatus(inst) !== "Paid" && props.getFeeStatus(inst) !== "Bad Debt";
});

  if (validInstallments.length < 15) {

    let data  = props.selectedInstallments
    let student_id = props.student_id
    let institute_id = props.institute_id
    let user_id = props.user_id
    let installments = '',
      ids = ''
      installments = data.map(el => el.install_no).join(",");
      ids = data.map(el => el.f_schld_id).join(",");
      
     
   
    let schedule_ids = []
    schedule_ids = data.map(el => el.f_schld_id)
    let total_Amount =amountToPay
    let extra_Charge = calculateExtCharge(amountToPay, props.razorpay_fee, props.student_fee_enable);
    let final_total = 0;
    
    if (Number(total_Amount) % 1 !== 0) {
      final_total = total_Amount;
    } else {
      // Add extra charge only if student_fee_enable is true
      final_total = amountToPay + (props.student_fee_enable ? extra_Charge : 0);
    }
    
    final_total = final_total.toFixed(2);
    let final_amt = (final_total * 100).toFixed(2).toString();
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );
    if (!res) {
    handleClosee = () => {
        alert("close")
      };
    handleOkk = () => {
        alert("open")
      };
      return;
    } else {
    let notesNew = {
      paid_date: new Date().toISOString().split('T')[0],
      institute_id: props.institute_id,
      reference_no: '',
      remarks: '',
      student_id: props.student_id,
      online_payment_amount:final_amt,
      payment_for: 'Fee',
      // is_transport_request: this.props.route.params?.isTransportChecked ?? false,
      actual_amount_paid: final_total === 0 ? amountToPay / 100 : amountToPay, // Use amountToPay

      version: 'v2',
      schedule_ids: schedule_ids.join(','),
    }

    const orderCreatetRequest = {
  
      amount: final_amt,
      currency: "INR",
      notes: {
        institute_id: props.institute_id,
        online_payment_amount: final_amt,
        paid_date: new Date().toISOString().split('T')[0],
        payment_for: 'Fee',
        reference_no: '',
        remarks: '',
        student_id: props.student_id,
        user_id: props.user_id,
        actual_amount_paid: final_total === 0 ? amountToPay / 100 : amountToPay, // Use amountToPay

      version: 'v2',
      schedule_ids: schedule_ids.join(','), 
      },
    }

    //orderCreateApi
    const result =props.pr.Razorpay.is_oAuth_done ? await orderCreate(orderCreatetRequest) : null
  
   
    let options = {
      key: props?.pr?.Razorpay?.is_oAuth_done
          ? props?.pr?.Razorpay?.public_token
          : CRED.RAZORPAY_KEY,
      handler: (response) => {
        if (props?.pr?.Razorpay?.is_oAuth_done) {
          updateOrderForRazorPay(response.razorpay_payment_id, result?.order_id);
        } else {
          updateOrder(true, response.razorpay_order_id, result?.razorpay_payment_id);
        }},
      theme: {
        color: 
          "--theme-color"
        ,
      },
      currency: "INR",
      name: "Merchant Name",
      description: 'Fee payment',
      theme: {
        color:"#54555f"
        ,
        
      },
      modal: {
        escape: false,
        ondismiss: function () {
          history.push("/fees");
        },
      },
      notes: notesNew,
      
      
    }
    if (props.pr.Razorpay.is_oAuth_done && result?.razorpay_order_id) {
      options["order_id"] = result?.razorpay_order_id;
    }
    
    if (props.pr.Razorpay.is_oAuth_done) {
      if (!result || !result?.razorpay_order_id) {
        toast.error(t('fees.paymentOrderNotCreated'), "fail");
        return;
      }
    }

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };
    // let rzp = new window.Razorpay(options);
    // console.log("rzp",rzp)
    // rzp.on("modal.closed", () => {
    //   history.push("/fees"); // Navigate to Fees page
    // });

    // rzp.on("payment.failed", (response) => {
    //   // Handle payment failure if needed
    // });
    // rzp.open();
   
    // }
   }
  else if (studentFeeReportJsonList.length > 15) {
    toast.error(t('fees.maxInstallmentsError'))
  }
  }

  const orderCreate = async (payload) => {
  
    let request = {
      url: `/api/v2/onlinePayment/create_order`,
      token: props.student_auth,
      data: payload,
    };
  
  
    return api
      .postAuth(request)
      .then((data) => {
  
        if (data.data.statusCode === 200) {
  
          const { order_id, razorpay_order_id } = data.data.result;
  
          return { order_id, razorpay_order_id }; // ✅ Return the result
        } else {
          toast.error(data.data.message);
          return null; // ✅ Return null to prevent undefined
        }
      })
      .catch((err) => {
        const errorMessage =
          err.data && err.data.data && err.data.data.message
            ? err.data.data.message
            : "unableToPay";
            toast.error(errorMessage);
        return null; // ✅ Return null on error
      });
  };  


const getStudentFeeReportJsonList = () => {
  let data = props.selectedInstallments
  let arr = []
  for (let index = 0; index < data.length; index++) {
    arr.push({
      // due_date: datseLib(data[index].d_date).format('YYYY-MM-DD'),
      fee_schedule_id: data[index].f_schld_id,
      paid_full: 'Y',
      previous_balance_amt: data[index].d_amount,
      total_amt_paid: data[index].t_amount,
    })
  }
  return arr
}
  
  const handleSelection = (gateway, data) => {
          if (selectedPayment === gateway) {
              // If clicking the same option again, deselect it
              setSelectedPayment(null);
              setDataItem(null);
          } else {
              // Otherwise, select it
              setSelectedPayment(gateway);
              setDataItem(data);
          }
      };


      // Reset partial payment input whenever modal opens
useEffect(() => {
  if (props.show) {
    setPartialAmount("");   // Clear the input
    setErrorMessage("");    // Clear any previous error
    setSelectedPayment(null); // Optional: reset selected payment
  }
}, [props.show]);

      var isPartPayment=props.pr?props.pr.inst_sett_det.is_part_pay_allowed:"false"
  // console.log("h",props.pr.inst_sett_det.is_part_pay_allowed)
  if (!props.show) return null;

      return (
        <>
        <ToastContainer />

       <div className="custom-modal">
       <div className="modal-content-popup">
        <span className="close" onClick={props.handleClose}>
            &times;
        </span>
        {!noGatewayAvailable && (
      <h2 style={{ padding: "12px" }}>{t('fees.selectPaymentGateway')}</h2>
    )}

    <div className="lineHor"></div>

    {noGatewayAvailable ? (
      <div
        style={{
          padding: "20px",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
Payment gateway is disabled. Please contact the admin     
 </div>
    )  : (
            <>
            
        {isPartPayment==="true" && (
  <div className="partial-payment-box">
    <div className="input-wrapper">
      <span className="currency-symbol">Rs</span>
      <input
        type="text"
        value={partialAmount}
        maxLength={7}
        onChange={handleAmountChange}
        inputMode="numeric"
        pattern="[0-9]*"
        placeholder={t('fees.enterAmountPlaceholder')}
        className="partial-payment-input"
      />
    </div>
    {errorMessage && <p className="error-message">{errorMessage}</p>}
 
        <div className="lineHor"></div>
        </div>
      )}

        {/* ✅ Razorpay Option */}
        {props.pr?.Razorpay?.is_active === "Y" && (
            <>
                <div className="modal-row">
                    <div className="custom-radio">
                        <input
                            type="radio" 
                            name="payment"
                            value="razorpay"
                            checked={selectedPayment === "razorpay"}
                            onChange={() => {
                                handleSelection("razorpay", { totalFee, extraCharge });
                                // setPartialAmount(""); // ✅ Reset input amount to 0
                            }}
                        />
                    </div>
                    <div className="logo">
                        <img src={Razorepay} alt="Razorpay" />
                    </div>
                    <div className="details">
                        <p>Amount</p>
                        <p>Conv. Fees</p>
                        <p style={{ fontWeight: "700" }}>Total Amount</p>
                    </div>
                    <div className="amount">
                        <p>
                            <span>Rs. </span>{totalFee.toFixed(2)}
                        </p>
                        <p>
                            <span>Rs. </span> {extraCharge.toFixed(2)}
                        </p>
                        <p>
                            <span>Rs. </span> 
                            <span style={{ fontWeight: "700" }}>
                                {(totalFee + extraCharge).toFixed(2)}
                            </span>
                        </p>
                    </div>
                </div>
                <div className="lineHor"></div>
            </>
        )}

        {/* ✅ Atom Option */}
        {props.pr?.Atom?.is_active === "Y" && (
            <>
                <div className="modal-row">
                    <div className="custom-radio">
                        <input
                            type="radio" 
                            name="payment"
                            value="atom"
                            checked={selectedPayment === "atom"}
                            onChange={() => handleSelection("atom", { amount: totalFee })}
                        />
                    </div>
                    <div className="logo">
                        <img src={Attom} alt="Atom" />
                    </div>
                    <div className="details">
                        <p>Amount</p>
                    </div>
                    <div className="amount">
                        <p>
                            <span>Rs. </span> {totalFee.toFixed(2)}
                        </p>
                    </div>
                </div>
                <div className="lineHor"></div>
            </>
        )}

        {/* ✅ Continue Button */}
        <button
            onClick={handlePaymentProceed}
            disabled={!selectedPayment}
            className={`continue-btn ${!selectedPayment ? "disabled" : ""}`}
        >
            Continue
        </button>
        </>
        )}
    </div>
</div>
</>
      )
};

  
  

  
    export default PaymentGatewayModal;
